module.exports = __webpack_public_path__ + "img/wp-new-habit-card9.c1334889.jpg";